'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Footer(brandLine, tagline, nav, policiesTitle, note, copyright) {
  this.he = null;
  this.hj = null;
  this.hg = null;
  this.hi = null;
  this.hh = null;
  this.hf = null;
  this.he = brandLine;
  this.hj = tagline;
  this.hg = nav;
  this.hi = policiesTitle;
  this.hh = note;
  this.hf = copyright;
}
export { $c_Lio_intela_sites_intelacloud_content_Footer as $c_Lio_intela_sites_intelacloud_content_Footer };
$p = $c_Lio_intela_sites_intelacloud_content_Footer.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Footer;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Footer() {
}
export { $h_Lio_intela_sites_intelacloud_content_Footer as $h_Lio_intela_sites_intelacloud_content_Footer };
$h_Lio_intela_sites_intelacloud_content_Footer.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-918235187), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Footer)) {
    if (((this.he === x$0.he) && (this.hj === x$0.hj))) {
      var x = this.hg;
      var x$2 = x$0.hg;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if ((($x_1 && (this.hi === x$0.hi)) && (this.hh === x$0.hh))) {
      return (this.hf === x$0.hf);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 6;
});
$p.I = (function() {
  return "Footer";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.he;
      break;
    }
    case 1: {
      return this.hj;
      break;
    }
    case 2: {
      return this.hg;
      break;
    }
    case 3: {
      return this.hi;
      break;
    }
    case 4: {
      return this.hh;
      break;
    }
    case 5: {
      return this.hf;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Footer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bu)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Footer as $isArrayOf_Lio_intela_sites_intelacloud_content_Footer };
var $d_Lio_intela_sites_intelacloud_content_Footer = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Footer, "io.intela.sites.intelacloud.content.Footer", ({
  bu: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Footer as $d_Lio_intela_sites_intelacloud_content_Footer };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Footer.js.map
